import React from 'react';
import { TabsTimelineSub } from 'components';
import { tabsBusinessPlan } from './tabsBusinessPlan';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';

const BusinessPlan = () => {
  const dispatch = useDispatch();
  const currentSubTab =
    useSelector(state => state.forms.carrier.currentSubTab) || 0;

  const setCurrentSubTab = arg => {
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'currentSubTab',
        value: arg,
      })
    );
  };

  return (
    <TabsTimelineSub
      tabs={tabsBusinessPlan()}
      current={currentSubTab}
      setCurrent={setCurrentSubTab}
      customClass={'custom-tabs-timeline-sub'}
    />
  );
};

export default BusinessPlan;
